<template>
  <div
    class="app-content content"
    :class="[{'show-overlay': $store.state.app.shallShowOverlay}, $route.meta.contentClass, $route.name == 'home' ? 'without-footer' : '']"
  >
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div
      @drag="onDrag"
      @drop="onDrop"
      class="content-wrapper"
      :class="contentWidth === 'boxed' ? 'container p-0' : null"
    >
      <Chatbot v-if="isChatOpen" :isDragEnter="isDragEnter"/>
      <div v-if="isMinimize"
        class="chat-bot-bubble-minimize"
        :class="viewHasSidebar ? 'chat-bot-bubble-minimize-sidenavbar' : ''"
        @click="maximizeChatbot">
        <img
          :src="chatBotIconUrl"
          alt="SBO chat bot icon bubble"
        />
      </div>
      <slot name="breadcrumb">
        <app-breadcrumb />
      </slot>
      <div class="content-body h-100">
        <transition
          :name="routerTransition"
          mode="out-in"
          >
          <slot
          class="h-100"

          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from '@vue/composition-api';
import store from "@/store";
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import Chatbot from '@/components/chatbot/Chatbot.vue';
import { useDefineChatbot } from "@/composables/defineChatbot";

export default {
  components: {
    AppBreadcrumb,
    Chatbot
  },
  setup() {
    const { routerTransition, contentWidth } = useAppConfig()
    const isDragEnter = ref(false)
    const isChatOpen = computed(() => store.state.chatbot.isOpen);
    const isMinimize = computed(() => store.state.chatbot.isMinimize);
    const chatBotIconUrl = require("@/assets/images/logo/OmniChatBot.svg")
    const { maximizeChatbot, viewHasSidebar } = useDefineChatbot()

    const onDrag = (e)=> {
      e.preventDefault()
      isDragEnter.value = true
    }
    const onDrop = (e)=> {
      e.preventDefault()
      isDragEnter.value = false
    }

    watch(
      () => isDragEnter.value,
      (value) => {
        if (value) {
        setTimeout(() => {
          isDragEnter.value = false
        }, 2000);
      }
      }
    );

    return {
      routerTransition,
      contentWidth,
      isDragEnter,
      isChatOpen,
      onDrag,
      onDrop,
      chatBotIconUrl,
      maximizeChatbot,
      isMinimize,
      viewHasSidebar
    }
  },
}
</script>

<style>

</style>
